
const PageLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      
      {/* GIF */}
      <img
        src="https://seniorsbluebook.com/common-assets/images/loader.gif"
        alt="Loading..."
        className="w-56 h-56 object-contain"
      />

      {/* Text */}
      <p className="mt-4 text-lg font-semibold text-indigo-700 animate-pulse">
        Loading Academic Portal...
      </p>

    </div>
  );
};

export default PageLoader;
